import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/Development.css'
import frontendImg from "../../assets/images/frontend.jpeg";
import backendImg from "../../assets/images/backend.png";
import fullstackImg from "../../assets/images/fullstackdeveloper.png";
import ecommerceImg from "../../assets/images/ecommercedevelopment.jpg";
import mobileappImg from "../../assets/images/mobileappdevelopment.png";

const Development = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: "Front-End Development",
      description:
        "We craft beautiful and responsive interfaces using React, Angular, and Vue.",
      image: frontendImg,
      link: "/services/development/frontend",
    },
    {
      title: "Back-End Development",
      description:
        "Our backend experts build secure and scalable systems using Node.js, Python, PHP, and more.",
      image: backendImg,
      link: "/services/development/backend",
    },
    {
      title: "Full Stack Development",
      description:
        "End-to-end application development with seamless front and back-end integration.",
      image: fullstackImg,
      link: "/services/development/fullstack",
    },
    {
      title: "E-commerce Development",
      description:
        "Robust online stores powered by Shopify, WooCommerce, Magento, or custom platforms.",
      image: ecommerceImg,
      link: "/services/development/ecommerce",
    },
    {
      title: "Mobile App Development",
      description:
        "Creating native and cross-platform mobile apps using Flutter, React Native, Kotlin, Swift, and more.",
      image: mobileappImg,
      link: "/services/development/mobileapp",
    },
  ];

  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Development Services – BuddyTech Solutions </title>
        <meta name="description" content="Frontend, backend, full‑stack, e‑commerce & mobile app development tailored for your business goals." />
        <meta name="keywords" content="development, frontend, backend, full-stack, e-commerce, mobile app" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Development Services – BuddyTech Solutions" />
        <meta property="og:description" content="Frontend, backend, full‑stack, e‑commerce & mobile app development tailored for your business goals." />
        <meta property="og:keywords" content="development, frontend, backend, full-stack, e-commerce, mobile app" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/development" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Development Services – BuddyTech Solutions" />
        <meta name="twitter:description" content="Frontend, backend, full‑stack, e‑commerce & mobile app development tailored for your business goals." />
        <meta name="twitter:keywords" content="development, frontend, backend, full-stack, e-commerce, mobile app" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="dev-container">
        <header className="dev-hero">
          <h1>Development Services</h1>
          <p>Explore our diverse development capabilities tailored to elevate your business.</p>
        </header>
        <section className="dev-services">
          {services.map((service, index) => (
            <div className="dev-card" key={index} onClick={() => navigate(service.link)}>
              <img src={service.image} alt={service.title} className="dev-card-img" />
              <div className="dev-card-body">
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <button className="dev-btn">Explore</button>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  )
}

export default Development
